import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=548384bc&scoped=true&"
import script from "./Spinner.vue?vue&type=script&lang=ts&"
export * from "./Spinner.vue?vue&type=script&lang=ts&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=548384bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548384bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
